import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import {
  DeleteCardApprovalRuleResponse,
  GetCardApprovalRulesResponse,
  PostCardApprovalRuleResponse,
  UpsertCardApprovalRuleBody,
} from 'src/queries/organizations/cardApprovalRules/cardApprovalRules.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getCardApprovalRule = async (
  orgId: string,
): Promise<GetCardApprovalRulesResponse> => {
  return getResponseData(
    axios.get<GetCardApprovalRulesResponse>(
      `/organizations/${orgId}/approvalrules`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const postCardApprovalRule = async (
  orgId: string,
  body: UpsertCardApprovalRuleBody,
): Promise<PostCardApprovalRuleResponse> => {
  return getResponseData(
    axios.post<PostCardApprovalRuleResponse>(
      `/organizations/${orgId}/approvalrules`,
      body,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const deleteCardApprovalRule = async (
  orgId: string,
  approvalRuleId: string,
): Promise<DeleteCardApprovalRuleResponse> => {
  return getResponseData(
    axios.delete<DeleteCardApprovalRuleResponse>(
      `/organizations/${orgId}/approvalrules/${approvalRuleId}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
